import {TItemId} from 'src/constants';
import {ECacheTag, rootApi} from 'src/models';

const api = rootApi.injectEndpoints({
  overrideExisting: 'throw',
  endpoints: (builder) => ({
    getAccountManagers: builder.query<{id: number; name: string; login: string}[], void>({
      query: () => ({
        method: 'GET',
        url: '/user/management/account-manager/all',
        meta: {isShowError: true},
      }),
    }),
    changePersonalManager: builder.mutation<
      TAnyObject,
      {supportTenantId?: TItemId; tenantLeadId?: TItemId; responsibleManagerId: number}
    >({
      query: ({supportTenantId, tenantLeadId, responsibleManagerId}) =>
        tenantLeadId !== undefined
          ? {
              method: 'PATCH',
              url: `/tenantmanagement/tenant-lead/${tenantLeadId}`,
              data: {responsibleManagerId},
              meta: {
                isShowError: true,
                isShowSuccess: true,
                successMessageKey: 'LeadCompanyClients:notification.updateResponsibleManager',
              },
            }
          : {
              method: 'POST',
              url: `/tenantmanagement/tenant/${supportTenantId}/personal-manager/${responsibleManagerId}`,
              meta: {
                isShowError: true,
                isShowSuccess: true,
                successMessageKey: 'LeadCompanyClients:notification.updateResponsibleManager',
              },
            },
      invalidatesTags: (_, __, {supportTenantId, tenantLeadId}) =>
        tenantLeadId !== undefined
          ? [{id: tenantLeadId, type: ECacheTag.LEAD_CLIENTS}]
          : [{id: supportTenantId, type: ECacheTag.SUPPORT_CLIENTS}],
    }),
  }),
});

export const {useGetAccountManagersQuery, useChangePersonalManagerMutation} = api;
